/*Flexi Box Bundle Script Code*/

document.addEventListener('DOMContentLoaded', function () {
  let shouldPreserveScrollOnAutoTab = false;

  // Enable checkboxes after page load
  document.querySelectorAll("input[type='checkbox']").forEach(function(checkbox) {
    checkbox.disabled = false;
  });

  // Scroll to top on page load
  window.addEventListener("beforeunload", function () {
    window.scrollTo(0, 0);
  });

  // Show/Hide header tabs
  document.querySelectorAll('.tab').forEach(function(tab) {
    tab.addEventListener('click', function() {
      // Remove 'active-tab-content' from all tab contents
      document.querySelectorAll('.tab-content').forEach(function(content) {
        content.classList.remove('active-tab-content');
      });
      // Add 'active-tab-content' to the tab content with matching data-id
      var dataId = tab.getAttribute('data-id');
      var targetContent = document.querySelector(".tab-content[data-id='" + dataId + "']");
      if (targetContent) {
        targetContent.classList.add('active-tab-content');
      }
      // Remove 'active-tab' from all tabs
      document.querySelectorAll('.tab').forEach(function(t) {
        t.classList.remove('active-tab');
      });
      // Add 'active-tab' to all tabs within the same parent as the clicked tab
      tab.parentElement.querySelectorAll('.tab').forEach(function(t) {
        t.classList.add('active-tab');
      });
      // Update all bubble counters when switching tabs
      updateAllBubbleCounters();
      // Clear the search bar and trigger keyup event
      var searchbar = document.getElementById('searchbar');
      if (searchbar) {
        searchbar.value = '';
        var event = new KeyboardEvent('keyup', { bubbles: true });
        searchbar.dispatchEvent(event);
      }

      if (!shouldPreserveScrollOnAutoTab) {
        // Keep manual tab clicks behavior unchanged
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }

      shouldPreserveScrollOnAutoTab = false;
    });
  });

  // Sticky header on-scroll
let lastScrollTop = 0;

window.addEventListener('scroll', function () {
  const scrollTop = Math.max(window.pageYOffset, document.documentElement.scrollTop, 0);
  const height = window.innerHeight;

  document.querySelectorAll('.sticky-header').forEach(header => {
    
    // Show header after scrolling past viewport height
    if (scrollTop > height) {
      header.classList.add('show');
    } else {
      header.classList.remove('show');
    }

    // Detect scroll direction safely
    if (scrollTop > lastScrollTop + 2) { 
      header.classList.add('hide');   // scrolling down
    } else if (scrollTop < lastScrollTop - 2) {
      header.classList.remove('hide'); // scrolling up
    }
  });

  lastScrollTop = scrollTop;
}, { passive: true });


  // Bubble counter update function to updates all bubble counters based on current state
  function updateAllBubbleCounters() {
    document.querySelectorAll('.bubble-counter').forEach(counter => {
      const tabId = counter.id.match(/checkbox_count_tab_(\d+)/)[1];
      const checkedCount = document.querySelectorAll(`[data-id="tab${tabId}"] input:checked`).length;
      const selectionLimit = document.querySelector(`.tab-content[data-id="tab${tabId}"]`)?.getAttribute('data-product-limit');
      const isLimitReached = (checkedCount === parseInt(selectionLimit));
      const parentTab = counter.closest('.tab');
      const isActive = parentTab?.classList.contains('active-tab');
      
      // Reset classes
      counter.classList.remove('limit-reached', 'active-limit-reached');   
      if (isLimitReached) {
        counter.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" class="check-icon" width="11" height="9" viewBox="0 0 11 9" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.66802 1.37429L4.48642 7.85309L0.416016 4.46069L1.18402 3.53909L4.31362 6.14669L8.73201 0.625488L9.66802 1.37429Z" fill="#fff" stroke="#fff" stroke-width="0.5"/></svg>`;     
        if (isActive) {
          counter.classList.add('active-limit-reached');
        } else {
          counter.classList.add('limit-reached');
        }
      } else if (checkedCount > 0) {
        counter.textContent = checkedCount;
      } else {
        counter.textContent = '';
      }
    });
  }

  // Passing line-items on clicking submit button
  // document.getElementById("submit-btn").addEventListener("click", function (e) {
  //   e.preventDefault(); // Prevent default form submission
  //   const submitButton = e.target;
  //   submitButton.classList.add("loading");
  //   const isBuyNow = submitButton.textContent.toLowerCase().trim() === "buy now";
    
  //   if (isBuyNow && !submitButton.classList.contains("zecpe-btn")) {
  //     // Custom code for Zecpe buy now checkout function
  //     submitButton.classList.add("zecpe-btn");
  //     submitButton.classList.add("zecpe-btn-clicked");
  //     // * Stopping the event propagation
  //     // e.preventDefault();
  //     e.stopPropagation();
  //     e.stopImmediatePropagation();
  //     // Custom code for Zecpe buy now checkout function ends here
  //   }

  //   const flexiBoxForm = document.getElementById("flexi-box-form");
  //   const checkedInputs = flexiBoxForm.querySelectorAll("input:checked");
  //   const variantId = parseInt(flexiBoxForm.dataset.variantId);
  //   const parent_sku = flexiBoxForm.dataset.sku;
  //   const parent_price = parseFloat((flexiBoxForm.dataset.price)/100);
  
  //   // Get product data
  //   let itemCounter = 1;
  //   let bundleCounter = 1;
  //   let total_regular_price = 0;
  //   let priceMarkUp = 0;
    
  //   // Prepare properties objects with separate collections
  //   const itemProperties = {};
  //   const bundleProperties = {};
    
  //   // Add parent SKU property first to bundle properties
  //   bundleProperties['_bundle_product1'] = `${parent_sku}/0/1`;
  //   bundleCounter++;
    
  //   // Calculate total regular price
  //   checkedInputs.forEach(function(input) {
  //     total_regular_price += parseInt(input.dataset.price);
  //   });
    
  //   // Process checked inputs
  //   checkedInputs.forEach(function(input, index) {
  //     if (input.value === "No") {
  //       input.disabled = true;
  //     } else {
  //       // Add to ITEM properties
  //       itemProperties[`_ITEM${itemCounter}`] = input.value;
        
  //       // Calculate bundle price
  //       let proportional_price = parseFloat(((parseInt(input.dataset.price) / total_regular_price) * parent_price).toFixed(2));
  //       priceMarkUp += proportional_price;
  //       let lastDigit = parent_price - parseFloat(priceMarkUp.toFixed(2));
  //       let isLast = index === checkedInputs.length - 1;
        
  //       // Add to bundle properties
  //       if (isLast) {
  //         bundleProperties[`_bundle_product${bundleCounter}`] = `${input.dataset.sku}/${(proportional_price + lastDigit)}/1`;
  //       } else {
  //         bundleProperties[`_bundle_product${bundleCounter}`] = `${input.dataset.sku}/${proportional_price}/1`;
  //       }
  //       itemCounter++;
  //       bundleCounter++;
  //     }
  //   });
    
  //   // Combine properties in desired order
  //   let properties = {
  //     ...itemProperties,
  //     ...bundleProperties
  //   };
    
  //   // Prepare the cart add request
  //   fetch('/cart/add.js', {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       'Accept': 'application/json'
  //     },
  //     body: JSON.stringify({
  //       items: [{
  //         id: variantId,
  //         quantity: 1,
  //         properties: properties
  //       }],
  //       sections: ["mini-cart", "cart-icon-bubble"]
  //     })
  //   })
  //   .then(response => response.json())
  //   .then(data => {
  //     // console.log('Added to cart:', data);
  //     if (isBuyNow) {
  //       window.ZecpeCheckVariant(submitButton); // Zecpe buy now checkout function
  //     } 
  //     else {
  //       // Update mini-cart and cart icon
  //       if (data.sections) {
  //         document.getElementById('mini-cart').innerHTML = data.sections['mini-cart'];
  //         document.getElementById('cart-icon-bubble').innerHTML = data.sections["cart-icon-bubble"];
  //       }
  //       document.querySelector(".cart-drawer-container")?.firstElementChild?.click(); // Open cart drawer
  //       submitButton.classList.remove("loading"); // Remove button loading
  //     } 
  //   })
  //   .catch(error => {
  //     console.error('Error:', error);
  //   });
  // });

  // Get the total number of tabs
  const totalTabs = document.querySelectorAll(".tab").length;
  // Get all checkbox inputs
  let checkboxes = document.querySelectorAll("input[type='checkbox']");
  
  // Store the initial input values of checkboxes in an object on page load
  const initProdValues = {};
  checkboxes.forEach(function(checkbox) {
    initProdValues[checkbox.id] = checkbox.value.trim();
  });
  // console.log(initProdValues);

  // Checkbox click functionality code
  checkboxes.forEach(function(checkbox) {
    checkbox.addEventListener("click", function () {
      const initProductValue = initProdValues[this.id];
      let currProductValue = this.value.trim();
      // console.log("Initial:", initProductValue, "Current:", currProductValue);
  
      // Initial and Current checkbox values, reload if does not match
      if (currProductValue !== initProductValue) {
        location.reload();
      }
  
      let currProduct = this.getAttribute("data-id");
      let currProductDataId = this.getAttribute("data-id-products");
      let currTabId = Number(currProductDataId.split("_")[1]);
      let selectionLimit = document.querySelector(`.tab-content[data-id="tab${currTabId}"]`).getAttribute("data-product-limit");
  
      // Hide elements
      let productInfo = this.closest(".collection-item");
      if (productInfo) {
        productInfo.querySelectorAll(".added_to_cart, .product_counter").forEach(function(el) {
          el.classList.add("_hidden");
        });
         productInfo.querySelectorAll(".one-fourth-column").forEach(function(el) {
            el.classList.remove("is-active");
          });
      }
      if (this.checked) {
        if (productInfo) {
          productInfo.querySelectorAll(".added_to_cart, .product_counter").forEach(function(el) {
            el.classList.remove("_hidden");
          });
           productInfo.querySelectorAll(".one-fourth-column").forEach(function(el) {
            el.classList.add("is-active");
          });
        }
        let productTitle = this.value.split("/")[0];
        document.querySelectorAll(".message-bar").forEach(function(bar) {
          bar.classList.remove("is-hidden");
          let span = bar.querySelector("p span");
          if (span) span.textContent = productTitle;
          setTimeout(function () {
            bar.classList.add("is-hidden");
            if (span) span.textContent = "";
          }, 2500);
        });
      }
      // Count checked checkboxes in current tab
      let n = document.querySelectorAll(`[data-id=tab${currTabId}] input:checked`).length;
      // console.log(currTabId, selectionLimit);
      // console.log(n);
  
      // Enable/disable checkboxes based on selection limit
      let notChecked = document.querySelectorAll(`[data-id=tab${currTabId}] input:not(:checked)`);
      let action = true;
      if (n == selectionLimit) {
        notChecked.forEach(function(input) {
          input.disabled = true;
        });
      } else {
        action = false;
        notChecked.forEach(function(input) {
          input.disabled = false;
        });
      }
      if (n > selectionLimit) {
        location.reload();
      }
      // Update bubble counters when checkbox selection changes
      updateAllBubbleCounters();
  
      // Go to next tab after adding mandatory items
      if (action === true) {
        let nextTab = `tab${currTabId + 1}`;
        let nextTabElem = document.querySelector(`.tab[data-id='${nextTab}']`);
        if (nextTabElem) {
          shouldPreserveScrollOnAutoTab = true;
          nextTabElem.click();
        }
  
        // Clear search
        let searchbar = document.getElementById("searchbar");
        if (searchbar) {
          searchbar.value = "";
          let event = new KeyboardEvent('keyup', { bubbles: true });
          searchbar.dispatchEvent(event);
        }
  
      }
  
      // Enabling submit btn if all mandatory products are selected
      let totalChecked = document.querySelectorAll("#flexi-box-form input[type=checkbox]:checked").length;
      let submitBtn = document.getElementById("submit-btn");
      let pouchBanner = document.getElementById("sticky-pouch-banner");
      if (submitBtn) {
        if (typeof totalproductSelection !== "undefined" && totalChecked == totalproductSelection) {
          submitBtn.style.display = "inline-block";
          if (pouchBanner) pouchBanner.style.display = "block";
          productInput.removeAttribute("disabled");
        } else {
          submitBtn.style.display = "none";
          if (pouchBanner) pouchBanner.style.display = "none";
        }
      }
    });
  });

  // Disable right-click context menu
  document.addEventListener("contextmenu", function(e) {
    e.preventDefault();
  });
  // Disable F12 key (Inspect Element)
  document.addEventListener("keydown", function(e) {
    if (e.key === "F12" || e.keyCode === 123) {
      e.preventDefault();
      return false;
    }
  });

  // Custom search bar functionality
  document.getElementById("searchbar").addEventListener("keyup", function () {
    var value = this.value.toLowerCase();
    document.querySelectorAll("#collection-list li").forEach(function (li) {
      var link = li.querySelector(".product_flexi_title");
      li.style.display = (link && link.textContent.toLowerCase().includes(value)) ? "" : "none";
    });
  });
  // Clear search on pressing clear button
  document.querySelectorAll(".search-clear").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      var searchbar = document.getElementById("searchbar");
      searchbar.value = "";
      // Trigger keyup event
      var event = new KeyboardEvent('keyup', { bubbles: true });
      searchbar.dispatchEvent(event);
    });
  });
});

    //Gokwik Code To Fetch
    window.addEventListener('DOMContentLoaded', (event) => {
      document.getElementById('submit-btn').addEventListener('click', (event) => {
        event.preventDefault();
        const flexiBoxForm = document.getElementById('flexi-box-form');
        const checkedInputs = flexiBoxForm.querySelectorAll('input:checked');
        const variantId = parseInt(flexiBoxForm.dataset.variantId);
        const parent_sku = flexiBoxForm.dataset.sku;
        const parent_price = parseFloat(flexiBoxForm.dataset.price / 100);

        let itemCounter = 1;
        let bundleCounter = 1;
        let total_regular_price = 0;
        let priceMarkUp = 0;

        const itemProperties = {};
        const bundleProperties = {};

        bundleProperties['_bundle_product1'] = `${parent_sku}/0/1`;
        bundleCounter++;

        // Safe rounding function
        function safeRound(num) {
          return Number(num.toFixed(2));
        }

        checkedInputs.forEach(function (input) {
          total_regular_price += parseInt(input.dataset.price);
        });

        checkedInputs.forEach(function (input, index) {
          if (input.value === 'No') {
            input.disabled = true;
          } else {
            itemProperties[`_ITEM${itemCounter}`] = input.value;

            // Proportional price safely rounded
            let proportional_price = safeRound((parseInt(input.dataset.price) / total_regular_price) * parent_price);

            priceMarkUp = safeRound(priceMarkUp + proportional_price);

            let lastDigit = safeRound(parent_price - priceMarkUp);
            let isLast = index === checkedInputs.length - 1;

            let finalPrice = isLast ? safeRound(proportional_price + lastDigit) : proportional_price;

            bundleProperties[`_bundle_product${bundleCounter}`] = `${input.dataset.sku}/${finalPrice}/1`;

            itemCounter++;
            bundleCounter++;
          }
        });

        let properties = {
          ...itemProperties,
          ...bundleProperties,
        };
        onBuyNowClick(event, false, [
          {
            id: variantId,
            quantity: 1,
            properties: properties,
          },
        ]);
      });
    });
  